import gql from "graphql-tag";

const getUserPortfolio = gql`
  query getUserPortfolio($offset: Float!, $limit: Float!) {
    getUserPortfolio(userPortfolioInput: { offset: $offset, limit: $limit }) {
      id
      poolId
      projectName
      projectImageUrl
      status
      contribution
      tokensPerOneCurrency
      receivedTokensPercentage
      contributionAddress
      poolPrice
      percentageFromPoolPrice
      details
      distributionStatusDescription
      distributionScAddress {
        networkId
        token
        address
        isClaimable
        isAirdropped
      }
      poolRefundPolicy {
        refundable
        explicitRefundWindowInSeconds
      }
      investmentRefundPayload {
        status
        requestedDate
        refundedDate
      }
      poolTgeDate
      totalTokenClaimed
      totalTokenClaimable
      isExternalProject
      code
    }
  }
`;

export default getUserPortfolio;
